import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box, Container, Grid, Typography, Link, TextField, Button } from '@mui/material';

const Footer = () => {
  return (
    <Box component="footer" sx={{ bgcolor: 'background.paper', py: 6, bgcolor: '#333', color: 'white' }}>
      <Container maxWidth={false}>
        <Grid container spacing={4} justifyContent="space-between">
          <Grid item xs={12} sm={4}>
            <Typography variant="h6" color="white" gutterBottom>
              Newsletter
            </Typography>
            <Typography variant="body2" color="white" paragraph>
              Subscribe to our newsletter for updates and promotions.
            </Typography>
            <Box component="form" noValidate>
              <TextField
                fullWidth
                label="Email Address"
                variant="outlined"
                size="small"
                margin="normal"
                sx={{
                  '& .MuiOutlinedInput-root': {
                    '& fieldset': { borderColor: 'rgba(255, 255, 255, 0.23)' },
                    '&:hover fieldset': { borderColor: 'rgba(255, 255, 255, 0.5)' },
                    '&.Mui-focused fieldset': { borderColor: 'white' },
                  },
                  '& .MuiInputLabel-root': { color: 'rgba(255, 255, 255, 0.7)' },
                  '& .MuiInputBase-input': { color: 'white' },
                }}
              />
              <Button variant="contained" color="primary" sx={{ mt: 1 }}>
                Subscribe
              </Button>
            </Box>
          </Grid>
          <Grid item xs={12} sm={4}>
            <Typography variant="h6" color="white" gutterBottom>
              Quick Links
            </Typography>
            <Link component={RouterLink} to="/search" color="inherit" display="block">Search</Link>
            <Link component={RouterLink} to="/terms-of-service" color="inherit" display="block">Terms of Service</Link>
            <Link component={RouterLink} to="/privacy-policy" color="inherit" display="block">Privacy Policy</Link>
            <Link component={RouterLink} to="/contact" color="inherit" display="block">Contact</Link>
            <Link component={RouterLink} to="/refund-policy" color="inherit" display="block">Refund Policy</Link>
          </Grid>
          <Grid item xs={12} sm={4}>
            <Typography variant="h6" color="white" gutterBottom>
              About Us
            </Typography>
            <Typography variant="body2" color="white">
              We are a leading online store providing high-quality products to our customers. Our mission is to deliver exceptional shopping experiences and top-notch customer service.
            </Typography>
          </Grid>
        </Grid>
        <Box mt={5}>
          <Typography variant="body2" color="white" align="center">
            {'Copyright © '}
            <Link color="inherit" href="https://your-website.com/">
              Your Website
            </Link>{' '}
            {new Date().getFullYear()}
            {'.'}
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;